// Shared so the Receiving tab and the project-detail inbound-deliveries panel
// render identical status colors. One distinct color per status, in workflow order.
export const RECEIVING_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  'Need More Info':                { bg: '#FBE4DF', text: '#8F2414' }, // red    — blocked, needs requestor
  'Submitted':                     { bg: '#E1EEF7', text: '#0D4C7C' }, // blue   — new
  'Request Received':              { bg: '#E7E5F7', text: '#3B2E86' }, // indigo — acknowledged
  'Shipment Partially Received':   { bg: '#FBECDC', text: '#8A4515' }, // amber  — partial
  'Available for Pickup':          { bg: '#DCF1F0', text: '#0B5C58' }, // teal   — ready for pickup
  'In Warehouse':                  { bg: '#E6F2EB', text: '#015A28' }, // green  — received
  'Delivery Scheduled to Jobsite': { bg: '#EBF3D6', text: '#4C6212' }, // olive  — outbound to site
  'Order Fulfilled':               { bg: '#EDEDEC', text: '#454543' }, // gray   — closed
};

export function ReceivingStatusBadge({ label }: { label: string }) {
  const c = RECEIVING_STATUS_COLORS[label] ?? { bg: '#f3f4f6', text: '#6b7280' };
  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 'var(--ew-r-sm)', fontSize: 11, fontWeight: 600, background: c.bg, color: c.text, letterSpacing: '0.04em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
      {label}
    </span>
  );
}
